// extracted by mini-css-extract-plugin
export default {"banner":"WithNav_banner__9eK-0","rightLeft":"WithNav_rightLeft__7m3HQ"};